import {
  SET_USER_SIGNUP_REQUEST,
  SET_USER_SIGNUP_SUCCESS,
  SET_USER_SIGNUP_FAILURE,
  GET_SIGNUP_LANGS_REQUEST,
  GET_SIGNUP_LANGS_SUCCESS,
  GET_SIGNUP_LANGS_FAILURE,
  SET_USER_SIGNUP_CONFIRM_CODE_REQUEST,
  SET_USER_SIGNUP_CONFIRM_CODE_SUCCESS,
  SET_USER_SIGNUP_CONFIRM_CODE_FAILURE,
  SET_USER_SIGNUP_SEND_CODE_REQUEST,
  SET_USER_SIGNUP_SEND_CODE_SUCCESS,
  SET_USER_SIGNUP_REGISTRATION_REQUEST,
  SET_USER_SIGNUP_REGISTRATION_SUCCESS,
  SET_USER_SIGNUP_REGISTRATION_FAILURE,
  SET_USER_SIGNUP_REVIEW_HAS_ERROR,
  SET_USER_SIGNUP_STEP_REQUEST,
  SET_USER_SIGNUP_STEP_SUCCESS,
  SET_USER_SIGNUP_STEP_FAILURE,
  SET_VALIDATE_SOCIAL_CHANNEL_REQUEST,
  SET_VALIDATE_SOCIAL_CHANNEL_SUCCESS,
  SET_VALIDATE_SOCIAL_CHANNEL_FAILURE,
  GET_INVITATION_CODE_REQUEST,
  GET_INVITATION_CODE_SUCCESS,
  GET_INVITATION_CODE_FAILURE,
} from "consts/actionTypes";

import { httpClient } from "lib/magiclinks-api/client";
import { tokenStorage } from "lib/magiclinks-api/token-storage";

const REGISTRATIONS_PATH = "/registrations";

export const userSignupApplication = (userData) => {
  return async (dispatch) => {
    dispatch({ type: SET_USER_SIGNUP_REQUEST });

    const result = await httpClient.postUnauthenticated(
      REGISTRATIONS_PATH,
      userData
    );

    if (result.success) {
      if (result.data.token) {
        tokenStorage.setToken(result.data.token);
      }
      dispatch({ type: SET_USER_SIGNUP_SUCCESS, data: result.data });
    } else {
      dispatch({ type: SET_USER_SIGNUP_FAILURE, err: result.error });
    }
  };
};

export const getUserRegistration = (callback) => {
  return async (dispatch) => {
    dispatch({ type: SET_USER_SIGNUP_REGISTRATION_REQUEST });

    const result = await httpClient.get(REGISTRATIONS_PATH + "/show");

    if (result.success && !result.data.error) {
      dispatch({
        type: SET_USER_SIGNUP_REGISTRATION_SUCCESS,
        data: { ...result.data.rewards_user },
      });
      if (callback && typeof callback === "function")
        callback(result.data.rewards_user.registration_step);
    } else {
      dispatch({ type: SET_USER_SIGNUP_REGISTRATION_FAILURE, err: null });
    }
  };
};

export const onUserSignUpByStep = (payload, action, callback) => {
  if (
    action !== "send_code" &&
    action !== "confirm_code" &&
    action !== "registrations"
  ) {
    throw new Error("Invalid action");
  }

  switch (action) {
    case "send_code":
      return async (dispatch) => {
        dispatch({ type: SET_USER_SIGNUP_REQUEST });
        dispatch({ type: SET_USER_SIGNUP_SEND_CODE_REQUEST });

        const result = await httpClient.postUnauthenticated(
          REGISTRATIONS_PATH + "/send_code",
          payload
        );

        if (result.success && !result.data.error) {
          dispatch({
            type: SET_USER_SIGNUP_SEND_CODE_SUCCESS,
            isEmailUsed: false,
          });
          if (callback) callback();
        } else {
          const error = result.data?.error || result.error;
          if (error === "email already registered") {
            dispatch({
              type: SET_USER_SIGNUP_SEND_CODE_SUCCESS,
              isEmailUsed: true,
            });
          } else {
            dispatch({ type: SET_USER_SIGNUP_FAILURE, err: error });
          }
        }
      };
    case "confirm_code":
      return async (dispatch) => {
        dispatch({ type: SET_USER_SIGNUP_CONFIRM_CODE_REQUEST });

        const result = await httpClient.getUnauthenticated(
          REGISTRATIONS_PATH + `/confirm_code?code=${payload}`
        );

        if (result.success) {
          if (result.data.error && result.data.error === "invalid code") {
            dispatch({
              type: SET_USER_SIGNUP_CONFIRM_CODE_FAILURE,
              error: result.data.error,
              hasErrorConfirmCode: "Invalid code. Try again.",
            });
          } else if (
            result.data.error &&
            result.data.error === "expired code"
          ) {
            dispatch({
              type: SET_USER_SIGNUP_CONFIRM_CODE_FAILURE,
              error: result.data.error,
              hasErrorConfirmCode:
                "Code has expired. Resend code and try again.",
            });
          } else if (!result.data.error) {
            dispatch({
              type: SET_USER_SIGNUP_CONFIRM_CODE_SUCCESS,
              data: result.data.signup_token,
            });
            if (callback) callback();
          }
        } else {
          const apiError = result.data?.error || result.error;
          let errorMessage = "Something went wrong. Please try again later.";

          if (apiError === "expired code") {
            errorMessage = "Code has expired. Resend code and try again.";
          } else if (apiError === "invalid code") {
            errorMessage = "Invalid code. Try again.";
          }

          dispatch({
            type: SET_USER_SIGNUP_CONFIRM_CODE_FAILURE,
            hasErrorConfirmCode: errorMessage,
          });
        }
      };
    case "registrations":
      return async (dispatch, getState) => {
        dispatch({ type: SET_USER_SIGNUP_STEP_REQUEST });
        const rewardsUser = getState().signup.rewardsUser;
        const isSubmit = payload?.rewards_user?.submit;
        const isCreate = rewardsUser && !rewardsUser.application_start_date;

        let result;
        if (isCreate) {
          result = await httpClient.postUnauthenticated(
            REGISTRATIONS_PATH,
            payload
          );
          if (result.success && result.data.token) {
            tokenStorage.setToken(result.data.token);
          }
        } else {
          result = await httpClient.put(
            REGISTRATIONS_PATH + "/update",
            payload
          );
        }

        if (result.success && !result.data.error) {
          if (
            payload.rewards_user.manager_email ||
            payload.rewards_user.manager_name ||
            payload.rewards_user.manager_reach_out
          ) {
            dispatch({
              type: SET_USER_SIGNUP_STEP_SUCCESS,
              data: {
                ...result.data.rewards_user,
                manager_represented: true,
                submit: !!isSubmit,
              },
            });
          } else {
            dispatch({
              type: SET_USER_SIGNUP_STEP_SUCCESS,
              data: { ...result.data.rewards_user, submit: !!isSubmit },
            });
          }
        } else {
          dispatch({ type: SET_USER_SIGNUP_STEP_FAILURE, err: result.error });
        }
      };
    default:
      break;
  }
};

export const validateSocialChannel = (channel, callback) => {
  return async (dispatch) => {
    dispatch({ type: SET_VALIDATE_SOCIAL_CHANNEL_REQUEST });

    const result = await httpClient.post(
      REGISTRATIONS_PATH + "/validate_channel",
      channel
    );

    if (result.success) {
      dispatch({
        type: SET_VALIDATE_SOCIAL_CHANNEL_SUCCESS,
        data: result.data,
      });
      dispatch(getUserRegistration());
      if (callback && typeof callback === "function") callback(result.data);
    } else {
      dispatch({
        type: SET_VALIDATE_SOCIAL_CHANNEL_FAILURE,
        err: result.error,
      });
    }
  };
};

export const removeSocialChannel = (channel, callback) => {
  return async (dispatch) => {
    dispatch({ type: SET_VALIDATE_SOCIAL_CHANNEL_REQUEST });

    const result = await httpClient.delete(
      REGISTRATIONS_PATH + "/delete_channel",
      channel
    );

    if (result.success) {
      dispatch({
        type: SET_VALIDATE_SOCIAL_CHANNEL_SUCCESS,
        data: result.data,
      });
      dispatch(getUserRegistration());
      if (callback && typeof callback === "function") callback(result.data);
    } else {
      dispatch({
        type: SET_VALIDATE_SOCIAL_CHANNEL_FAILURE,
        err: result.error,
      });
    }
  };
};

export const setReviewHasError = (hasError) => {
  return (dispatch) => {
    dispatch({ type: SET_USER_SIGNUP_REVIEW_HAS_ERROR, data: hasError });
  };
};

export const getAvailableLanguages = () => {
  return async (dispatch) => {
    dispatch({ type: GET_SIGNUP_LANGS_REQUEST });

    const result = await httpClient.getUnauthenticated(
      REGISTRATIONS_PATH + "/languages"
    );

    if (result.success) {
      dispatch({ type: GET_SIGNUP_LANGS_SUCCESS, data: result.data });
    } else {
      dispatch({ type: GET_SIGNUP_LANGS_FAILURE, err: result.error });
    }
  };
};

export const getInvitationCode = (code) => {
  return async (dispatch) => {
    dispatch({ type: GET_INVITATION_CODE_REQUEST });

    const result = await httpClient.getUnauthenticated(
      REGISTRATIONS_PATH + `/invitation_code?code=${code}`
    );

    if (result.success) {
      dispatch({ type: GET_INVITATION_CODE_SUCCESS, data: result.data });
    } else {
      dispatch({ type: GET_INVITATION_CODE_FAILURE, err: result.error });
    }
  };
};
